import { Link } from "react-router-dom";
import CantalBadge from "./CantalBadge";
import FavoriteButton from "./FavoriteButton";

export default function ProductCard({ product, idx = 0 }) {
  return (
    <Link
      to={`/product/${product.id}`}
      className="product-card group block bg-white rounded-3xl overflow-hidden border border-[#E5E1D8]/60 shadow-sm hover:shadow-xl transition-all duration-500"
      data-testid={`product-card-${product.id}`}
      style={{ animationDelay: `${idx * 60}ms` }}
    >
      <div className="relative aspect-[4/5] overflow-hidden bg-[#F7F5F0]">
        {product.images?.[0] && (
          <img
            src={product.images[0]}
            alt={product.name}
            className={`w-full h-full object-cover product-card-img ${product.stock === 0 ? "grayscale opacity-70" : ""}`}
          />
        )}
        {product.stock === 0 ? (
          <span className="absolute top-4 left-4 bg-[#1F1812] text-white text-[10px] uppercase tracking-[0.18em] px-3 py-1.5 rounded-full font-medium" data-testid={`out-of-stock-${product.id}`}>
            Rupture
          </span>
        ) : product.featured && (
          <span className="absolute top-4 left-4 bg-[#F2B544] text-[#1F1C18] text-[10px] uppercase tracking-[0.18em] px-3 py-1.5 rounded-full font-semibold shadow-md">
            Coup de cœur
          </span>
        )}
        <FavoriteButton productId={product.id} className="absolute top-4 right-4" />
      </div>
      <div className="p-5">
        {product.category && (
          <p className="text-xs uppercase tracking-[0.18em] text-[#6B655C] mb-2" data-testid={`product-category-${product.id}`}>{product.category}</p>
        )}
        <h3 className="font-serif-display text-xl text-[#1F1C18] mb-2 leading-tight group-hover:text-terracotta transition">
          {product.name}
        </h3>
        <CantalBadge testId={`cantal-badge-${product.id}`} />
        <div className="flex items-center justify-between mt-3">
          <span className="text-lg font-medium text-terracotta">{product.price.toFixed(2)} €</span>
          {product.rating > 0 && (
            <span className="text-xs text-[#6B655C]">★ {product.rating.toFixed(1)} ({product.reviews_count})</span>
          )}
        </div>
      </div>
    </Link>
  );
}
